export const buildersInfo = {
    name: 'Neelkanth Shivay Infra Developers Pvt Ltd',
    email : 'neelkanth-example@gmail.com',
    websiteLink : 'neelkanthshivay.com',
    address : "SHOP NO. - 603,604 6th floor Millennium place near lulu mall golf City Lucknow 226030",
    contact_number : "+919999999999",
}